module.exports = __webpack_public_path__ + "static/xeva-1b5dc1f02d64e8020ebf72de6a3b30bc.png";